import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, CheckIcon, CreditCardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { included, purchaseUrl } from '../data/content';
import { Countdown } from './ui/Countdown';
export function Pricing({
  id = 'pricing'
}: {
  id?: string;
}) {
  return <section id={id} className="scroll-mt-24 bg-canvas px-4 py-14 md:py-16" aria-labelledby={`${id}-title`} data-id="element-221" data-mp="3ns5xfgnswo5p">
      <div className="mx-auto max-w-2xl text-center" data-id="element-222" data-mp="kaw04ugoiadb">
        <p className="text-[11px] font-extrabold uppercase tracking-[.16em] text-accent-dark md:text-sm" data-id="element-223" data-mp="k9kuep3oasjk">
          ⏰ Precio de lanzamiento — cierra en:
        </p>
        <div className="mt-4" data-id="element-224" data-mp="ac6rztel44a9">
          <Countdown data-id="element-225" data-mp="abeuue5c9yhv" />
        </div>
        <p className="mt-4 inline-flex items-center gap-2 rounded-full border border-red-200 bg-red-50 px-4 py-2 text-xs font-extrabold text-red-600" data-id="element-226" data-mp="aeko85l03mje">
          <AlertTriangleIcon className="h-4 w-4" data-id="element-227" data-mp="2v4062b28s0ww" />
          Después sube $6.990 ARS. No vuelve.
        </p>

        <article className="mt-8 rounded-3xl border-4 border-accent bg-white p-6 text-left shadow-[0_24px_60px_rgba(7,16,29,.20)] md:p-9" data-id="element-228" data-mp="2fodrxhjeqctb">
          <div className="text-center" data-id="element-229" data-mp="2aquak8rexjx5">
            <span className="inline-flex rounded-full bg-primary px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-wide text-white" data-id="element-230" data-mp="2opbx435l0qdh">
              📊 El descuento que recibís HOY
            </span>
            <h2 id={`${id}-title`} className="mt-4 text-xl font-black text-ink md:text-3xl" data-id="element-231" data-mp="2ylezna4cir0y">
              Acceso a los 6 tomos + 5 bonos GRATIS
            </h2>
          </div>

          <ul className="my-7 space-y-2.5 border-y border-line py-6" data-id="element-232" data-mp="38crp5v2o953t">
            {included.map(item => <li key={item} className="flex items-start gap-2 text-sm font-semibold text-slate-700" data-id="element-233" data-mp="33cx262m0ozo1">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" data-id="element-234" data-mp="3hdzomggxcbzh" />
                {item}
              </li>)}
          </ul>

          <div className="text-center" data-id="element-235" data-mp="3cc0iwzxpp2zd">
            <p className="text-[11px] font-extrabold uppercase tracking-wide text-slate-500" data-id="element-236" data-mp="2a18duccnjc55">
              Antes
            </p>
            <p className="mt-1 text-2xl font-black text-slate-400 line-through" data-id="element-237" data-mp="2f01qy3o1114s">$78.940 ARS</p>
            <p className="mt-1 text-xs font-semibold text-slate-500" data-id="element-238" data-mp="2j0bzno37e5nc">
              Valor individual de los 6 tomos y los 5 bonos
            </p>
          </div>

          <div className="mt-6 text-center" data-id="element-239" data-mp="2srgaqcprd6cw">
            <p className="inline-flex rounded-full bg-accent px-3 py-1 text-xs font-extrabold uppercase tracking-wide text-white" data-id="element-240" data-mp="2sqf36i7yb1zx">
              75% de descuento · ahorrás $58.950 ARS
            </p>
            <div className="mt-6" data-id="element-241" data-mp="32pw3sl8cipp1">
              <motion.a href={purchaseUrl} target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.012
            }} whileTap={{
              scale: 0.988
            }} transition={{
              duration: 0.14,
              ease: [0.23, 1, 0.32, 1]
            }} className="flex w-full flex-col items-center gap-1 rounded-2xl bg-accent px-6 py-5 text-center shadow-[0_18px_38px_rgba(241,96,13,.36)] transition-colors duration-150 ease-out hover:bg-accent-dark focus:outline-none focus:ring-4 focus:ring-accent/30" data-id="element-242" data-mp="36qpoz6uelqe8">
                <span className="text-[11px] font-extrabold uppercase tracking-[.16em] text-white/90" data-id="element-243" data-mp="v19qbnfquvc0">
                  Hoy · precio de lanzamiento
                </span>
                <span className="text-3xl font-black leading-none text-white md:text-5xl" data-id="element-244" data-mp="1nri3t1zc4rk9">
                  $19.990 ARS
                </span>
                <span className="mt-1 text-sm font-extrabold uppercase tracking-wide text-white md:text-base" data-id="element-245" data-mp="1erbs9ln761nq">
                  🏃 Acceder al Combo Completo →
                </span>
              </motion.a>
            </div>
            <p className="mt-3 text-xs font-bold text-slate-500" data-id="element-246" data-mp="3cgfy6c0wcac">
              Una sola compra. Acceso de por vida.
            </p>
            <div className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[11px] font-semibold text-slate-500" data-id="element-247" data-mp="3ugwr09qwmuqq">
              <span className="flex items-center gap-1" data-id="element-248" data-mp="1r0hysest5pgw">
                <LockIcon className="h-3.5 w-3.5 text-accent" data-id="element-249" data-mp="1r22vob2lhkhx" /> Pago 100% seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-250" data-mp="1daod25clnlbe">
                <ZapIcon className="h-3.5 w-3.5 text-accent" data-id="element-251" data-mp="1ha6uus94jga0" /> Acceso en 5 minutos
              </span>
              <span className="flex items-center gap-1" data-id="element-252" data-mp="24zrivpk4x3q5">
                <ShieldCheckIcon className="h-3.5 w-3.5 text-accent" data-id="element-253" data-mp="24y6ivkf1wskw" /> Garantía 7 días
              </span>
              <span className="flex items-center gap-1" data-id="element-254" data-mp="29wzypjht8vo8">
                <CreditCardIcon className="h-3.5 w-3.5 text-accent" data-id="element-255" data-mp="1vyt8mpj3rzz4" /> Mercado Pago · Tarjeta ·
                Transferencia
              </span>
            </div>
          </div>
        </article>
      </div>
    </section>;
}